
import { createContext, Suspense, useContext, useMemo, useState } from "react";
import ProgressIndicatorView from "./views/common/ProgressIndicatorView";


const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
    const [inProgress, setInProgress] = useState(true);

    const showProgressIndicator = () => {
        setInProgress(true)
    }

    const hideProgressIndicator = () => {
        setInProgress(false)
    }
    const values = { showProgressIndicator, hideProgressIndicator };

    const memoObj = useMemo(() => (values), [inProgress]);
    return (
        <Suspense fallback={<ProgressIndicatorView/>} open={true}>
            <AppContext.Provider value={memoObj}>
                {children}
                {inProgress && <ProgressIndicatorView open={inProgress} />}
            </AppContext.Provider>
        </Suspense>
    );
}

export const useApp = () => {
    return useContext(AppContext);
};